export default __webpack_public_path__ + "static/media/bannerA.aeec426b.jpg";